<template>
  <div>
    <credit-form :currentUser="currentUser" />
  </div>
</template>

<script>
import CreditForm from '../components/CreditForm.vue';

export default {
  name: 'credits',
  components: {
    CreditForm,
  },
  data() {
    return {
      currentUserId: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
  },
};
</script>

<style lang="sass" scoped></style>
